/*


*/
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'
import VueAxios from 'vue-axios'
import { createHead } from '@vueuse/head'
import VueGtag from 'vue-gtag-next'
import Paginate from 'vuejs-paginate-next'

const app = createApp(App)
const head = createHead()

app.use(head)
app.use(router)
app.use(VueGtag, {
  property: {
    id: 'G-R6MVJKE8LV'
  }
})

app.use(VueAxios, axios)

app.component('paginate-list', Paginate)

app.mount('#app')
